import { EntityLink } from '@/shared/ui/entity-link'

interface EntityRefProps {
  id: string
  label?: string
  className?: string
}

export function UnitLink({ id, label, className }: EntityRefProps) {
  return (
    <EntityLink
      to="/units/$unitId"
      params={{ unitId: id }}
      icon="server"
      mono
      className={className}
    >
      {label ?? id}
    </EntityLink>
  )
}

export function CellLink({ id, label, className }: EntityRefProps) {
  return (
    <EntityLink to="/cells/$cellId" params={{ cellId: id }} icon="grid" mono className={className}>
      {label ?? id}
    </EntityLink>
  )
}
